<script setup lang="ts">
const { isLoading } = defineProps<{ isLoading?: boolean }>()
</script>

<template>
  <div v-show="isLoading" class="loading">
    <div class="d-flex justify-content-center">
      <div
        class="spinner-border text-danger"
        role="status"
        style="position: absolute; bottom: 50%"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>
